import { Compliance } from './compliance.model';

export class ModuleComplianceV1Read implements Compliance {
    id: string;
    name: string;
}
